// Dashboard Configuration Action Types

// Create Dashboard
export const CREATE_DASHBOARD_START = 'CREATE_DASHBOARD_START';
export const CREATE_DASHBOARD_SUCCESS = 'CREATE_DASHBOARD_SUCCESS';
export const CREATE_DASHBOARD_FAIL = 'CREATE_DASHBOARD_FAIL';

//dashboard assignment
export const GET_DASHBOARD_CONFIG_SUCCESS = "GET_DASHBOARD_CONFIG_SUCCESS";
export const DASHBOARD_CONFIG_FETCH_START = "DASHBOARD_CONFIG_FETCH_START";
export const DASHBOARD_CONFIG_FETCH_END = "DASHBOARD_CONFIG_FETCH_END";

// Get All Dashboards
export const GET_ALL_DASHBOARDS_START = 'GET_ALL_DASHBOARDS_START';
export const GET_ALL_DASHBOARDS_SUCCESS = 'GET_ALL_DASHBOARDS_SUCCESS';
export const GET_ALL_DASHBOARDS_FAIL = 'GET_ALL_DASHBOARDS_FAIL';

// Get Dashboard by ID
export const GET_DASHBOARD_BY_ID_START = 'GET_DASHBOARD_BY_ID_START';
export const GET_DASHBOARD_BY_ID_SUCCESS = 'GET_DASHBOARD_BY_ID_SUCCESS';
export const GET_DASHBOARD_BY_ID_FAIL = 'GET_DASHBOARD_BY_ID_FAIL';

// Get Dashboard by Name
export const GET_DASHBOARD_BY_NAME_START = 'GET_DASHBOARD_BY_NAME_START';
export const GET_DASHBOARD_BY_NAME_SUCCESS = 'GET_DASHBOARD_BY_NAME_SUCCESS';
export const GET_DASHBOARD_BY_NAME_FAIL = 'GET_DASHBOARD_BY_NAME_FAIL';

// Delete Dashboard
export const DELETE_DASHBOARD_START = 'DELETE_DASHBOARD_START';
export const DELETE_DASHBOARD_SUCCESS = 'DELETE_DASHBOARD_SUCCESS';
export const DELETE_DASHBOARD_FAIL = 'DELETE_DASHBOARD_FAIL';

// Clear Current Dashboard
export const CLEAR_CURRENT_DASHBOARD = 'CLEAR_CURRENT_DASHBOARD';

// Clear All Dashboard Data
export const CLEAR_ALL_DASHBOARDS = 'CLEAR_ALL_DASHBOARDS';
export const CLEAR_DASHBOARD_CACHE = 'CLEAR_DASHBOARD_CACHE';

// Get SQL Queries
export const GET_SQL_QUERIES_START = 'GET_SQL_QUERIES_START';
export const GET_SQL_QUERIES_SUCCESS = 'GET_SQL_QUERIES_SUCCESS';
export const GET_SQL_QUERIES_FAIL = 'GET_SQL_QUERIES_FAIL';

// SQL Query Columns
export const GET_SQL_QUERY_COLUMNS_START = 'GET_SQL_QUERY_COLUMNS_START';
export const GET_SQL_QUERY_COLUMNS_SUCCESS = 'GET_SQL_QUERY_COLUMNS_SUCCESS';
export const GET_SQL_QUERY_COLUMNS_FAIL = 'GET_SQL_QUERY_COLUMNS_FAIL';

// Run SQL Workbench
export const RUN_SQL_WORKBENCH_START = 'RUN_SQL_WORKBENCH_START';
export const RUN_SQL_WORKBENCH_SUCCESS = 'RUN_SQL_WORKBENCH_SUCCESS';
export const RUN_SQL_WORKBENCH_FAIL = 'RUN_SQL_WORKBENCH_FAIL';
